export default __webpack_public_path__ + "static/modal-background-zona-v@2x-2a245eda1a88c1998ab44ffb1652b11b.png";